const formatStatusParam = (status) => {
    if (!status || status.length === 0) return null;
  
    if (Array.isArray(status)) {
      return status.map(s => `status=${s}`).join('&');
    }
  
    return `status=${status}`;
};

export default formatStatusParam;
